module.exports = __webpack_public_path__ + "static/img/2.40531df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shao/2.jpg
// module id = tup7
// module chunks = 1